export default {
	MODAL_OPEN: 'MODAL_OPEN',
	MODAL_OPENED: 'MODAL_OPENED',

	MODAL_CLOSE: 'MODAL_CLOSE',
	MODAL_CLOSED: 'MODAL_CLOSED'
};
